import { defineStore } from 'pinia'
import i18n, { loadLanguageAsync } from "@/i18n/index.js"
const { t, locale } = i18n.global
import eventEmitter from "@/utils/emitter.js"

export const useLangStore = defineStore('localLang', {
  state: () => {
    return {
      language: localStorage.getItem('lang'),
      isLoadingLanguage: false, // 语言加载状态
    }
  },

  actions: {
    /**
     * 全局切换语言（懒加载版本）
     * @param {string} data - 语言字段
     * @returns {Promise} 返回Promise，确保语言加载完成
     */
    async changeLang(data) {
      // 如果是相同语言，直接返回
      if (this.language === data) {
        return Promise.resolve()
      }

      // 标记正在加载
      this.isLoadingLanguage = true

      try {
        // 动态加载语言包
        await loadLanguageAsync(data)

        // 更新状态
        this.language = data
        locale.value = this.language
        localStorage.setItem('lang', this.language)

        // 触发语言切换事件
        console.log('langchange: emit;', data)
        eventEmitter.emit('lang:change', data)

        return Promise.resolve()
      } catch (error) {
        console.error('切换语言失败:', error)
        return Promise.reject(error)
      } finally {
        // 加载完成
        this.isLoadingLanguage = false
      }
    },

    /**
     * 同步切换语言（兼容旧版本代码）
     * @param {string} data - 语言字段
     */
    changeLangSync(data) {
      if (this.language === data) return

      this.changeLang(data).catch(error => {
        console.error('语言切换失败:', error)
      })
    }
  },

  persist: true,
})